import $ from "../template/jquery"

// jQuery ajax shim: dentalkoo navigation.js uses dataType:'script' so Rails
// negotiates format.js, but the body is HTML. Skip eval for HTML responses.
$.ajaxSetup({
  converters: {
    "text script": function (text) {
      if (typeof text === "string" && /^\s*</.test(text)) {
        return text
      }
      $.globalEval(text)
      return text
    }
  }
})
